import base from './base';

export const language = { ...base };
